import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Feature } from 'ol';
import { FeatureNode } from '../../../../models/feature-note';
import { FeatureSelectService } from '../../../../services/feature-select.service';
import { PsaService } from '../../../../services/psa.service';

@Component({
  selector: 'ebw-monorepo-psa-feature-tree-element',
  templateUrl: './psa-feature-tree-element.html',
  styleUrls: ['./psa-feature-tree-element.scss']
})
export class PsaFeatureTreeElement implements OnInit {
  @Input() node: FeatureNode;
  @Input() selectedNode: FeatureNode;

  title = '';
  subtitle = '';

  @Output() onSelectedNodeFromRadioButton = new EventEmitter();

  // ---------------------------------------------------------------------------------

  constructor(public _psaService: PsaService, private _featureSelectService: FeatureSelectService) {}

  // ---------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getTitleAndSubtitleFieldsForList(this.node);
  }

  // ---------------------------------------------------------------------------------

  getTitleAndSubtitleFieldsForList(node: FeatureNode) {
    const feature: Feature = node.nodeData;
    const properties = feature.getProperties();

    const isReteIdrica = this._psaService.isUrnReteIdrica(node.id);
    const { collections } = this._featureSelectService.getCollectionConfig();

    isReteIdrica
      ? this.getInfoReteIdricaElement({ ...properties, ...properties.additional_info }, collections)
      : this.getInfoSchemaIdropotabileElement(properties, collections);
  }

  // ---------------------------------------------------------------------------------

  getInfoReteIdricaElement(properties, collections) {
    const nodeCollection = collections.find((c) => c.name === `rete_idrica.${properties.original_dataset}`);

    if (!nodeCollection) {
      this.title = properties.original_dataset;
      this.subtitle = properties.original_id;
      return;
    }

    // il titolo è sempre il nome esterno della collection
    this.title = properties.type;
    // il sottotitolo può essere composto da vari campi
    let subtitleFields = nodeCollection.fields.filter((f: any) => !!f.subtitle);
    // Se nessuna proprietà è stata trovata allora metto l'original_id dell'elemento

    if (subtitleFields.length === 0) {
      this.subtitle = properties.original_id;
    }
    if (subtitleFields.length === 1) {
      const subtitleField = subtitleFields[0].name;
      this.subtitle = properties[subtitleField];
    }

    if (subtitleFields.length > 1) {
      this.subtitle = subtitleFields.map((f) => properties[f.name]).join(' - ');
    }
  }

  // ---------------------------------------------------------------------------------

  getInfoSchemaIdropotabileElement(properties, collections) {
    const nodeCollection = collections.find((c) => c.name === `psa.schema_idropotabile`);

    // TITLE
    const titleFields = nodeCollection.fields.filter((f: any) => !!f?.title);
    if (titleFields.length === 0) {
      this.title = properties.search_term;
    }
    if (titleFields.length === 1) {
      const titleField = titleFields[0].name;
      this.title = properties[titleField];
    } else {
      this.title = titleFields.map((f) => properties[f.name]).join(' - ');
    }

    // SUBTITLE
    const subtitleFields = nodeCollection.fields.filter((f: any) => !!f?.subtitle);
    if (subtitleFields.length === 0) {
      this.subtitle = properties.tipologia;
    }
    if (subtitleFields.length === 1) {
      const subtitleField = subtitleFields[0].name;
      this.subtitle = properties[subtitleField];
    } else {
      this.subtitle = subtitleFields.map((f) => properties[f.name]).join(' - ');
    }
  }

  // ---------------------------------------------------------------------------------

  onSelect(event: MatRadioChange) {
    this.onSelectedNodeFromRadioButton.emit(event);
  }
}
